import api from "../../../lib/api";

export default {
  postOgp(data) {
    return api({
      endpoint: "ogp",
      path: "ogp",
      method: "POST",
      body: data
    });
  }
};
